import { Injectable } from '@angular/core';
import { BlockchainxHelper } from 'ng-blockchainx';
import { CommonContractService } from 'src/app/shared/services/common-contract.service';

@Injectable({
  providedIn: 'root',
})
export class MytokenService {
  public standardToken: any;
  public liquidityToken: any;
  public userTokenInstance: any;
  public tokenDecimal: any;

  constructor(
    private bxHelper: BlockchainxHelper,
    private commonContractService: CommonContractService
  ) {}

  public async init() {
    this.standardToken = await this.commonContractService.getContract(
      'STANDARD_TOKEN'
    );
    this.liquidityToken = await this.commonContractService.getContract(
      'LIQUIDITY_TOKEN'
    );
  }

  /**
   * Gets token
   * @param walletAddress
   * @param tokenAddress
   * @returns
   */
  public async getTokenDetails(walletAddress: string, tokenAddress: string) {
    let tokenContract = await this.commonContractService.getContractByAddress(
      'STANDARD_TOKEN',
      tokenAddress
    );

    try {
      var owner = await tokenContract.methods.owner().call();
      var isfromBX;
      isfromBX = await tokenContract.methods.fromBX().call();
    } catch (error) {
      console.log(error);
      isfromBX = 'null';
    }
    return { owner, isfromBX };
  }

  public async setTokenAddressAndType(tokenAddress: any, tokenType: any) {
    this.userTokenInstance =
      await this.commonContractService.getContractByAddress(
        tokenType,
        tokenAddress
      );
    this.tokenDecimal = await this.userTokenInstance.methods.decimals().call();
  }

  public async approveAbi(spender: any, tokenAmount: any) {
    let decimal = await this.tokenDecimal;
    const params = [
      spender,
      this.bxHelper.decimalMultipler(Number(decimal), tokenAmount),
    ];
    console.log('approve params : ', params);
    return await this.userTokenInstance.methods.approve(...params).encodeABI();
  }

  // public approve(walletAddress: string, tokenAddress: any, approveAbi: any) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: approveAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async transferAbi(to: any, tokenAmount: any) {
    let decimal = await this.tokenDecimal;
    const params = [
      to,
      this.bxHelper.decimalMultipler(Number(decimal), tokenAmount),
    ];
    console.log('transfer params : ', params);
    return await this.userTokenInstance.methods.transfer(...params).encodeABI();
  }

  // public transfer(walletAddress: string, tokenAddress: any, transferAbi: any) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: transferAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async transferFromAbi(from: any, to: any, tokenAmount: any) {
    let decimal = await this.tokenDecimal;
    const params = [
      from,
      to,
      this.bxHelper.decimalMultipler(Number(decimal), tokenAmount),
    ];
    console.log('transferFrom params : ', params);
    return await this.userTokenInstance.methods
      .transferFrom(...params)
      .encodeABI();
  }

  // public transferFrom(
  //   walletAddress: string,
  //   tokenAddress: any,
  //   transferFromAbi: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: transferFromAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async transferOwnershipAbi(newOwner: any) {
    const params = [newOwner];
    console.log('transfer ownership params : ', params);
    return await this.userTokenInstance.methods
      .transferOwnership(...params)
      .encodeABI();
  }

  // public transferOwnership(
  //   walletAddress: string,
  //   tokenAddress: any,
  //   transferOwnershipAbi: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: transferOwnershipAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async renounceOwnershipAbi() {
    return await this.userTokenInstance.methods.renounceOwnership().encodeABI();
  }

  // public renounceOwnership(
  //   walletAddress: string,
  //   tokenAddress: any,
  //   renounceOwnershipAbi: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: renounceOwnershipAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async pauseAbi() {
    return await this.userTokenInstance.methods.pause().encodeABI();
  }

  public async pauseContractAbi() {
    return await this.userTokenInstance.methods.pauseContract().encodeABI();
  }

  // public pause(walletAddress: string, tokenAddress: any, pauseAbi: any) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: pauseAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async unpauseAbi() {
    return await this.userTokenInstance.methods.unpause().encodeABI();
  }

  public async unpauseContractAbi() {
    return await this.userTokenInstance.methods.unPauseContract().encodeABI();
  }

  // public unpause(walletAddress: string, tokenAddress: any, unpauseAbi: any) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: unpauseAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async increaseAllowanceAbi(spender: any, value: any) {
    let decimal = await this.tokenDecimal;
    const params = [
      spender,
      this.bxHelper.decimalMultipler(Number(decimal), value),
    ];
    console.log('increase allowance params : ', params);
    return await this.userTokenInstance.methods
      .increaseAllowance(...params)
      .encodeABI();
  }

  // public increaseAllowance(
  //   walletAddress: string,
  //   tokenAddress: any,
  //   increaseAllowanceAbi: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: increaseAllowanceAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async decreaseAllowanceAbi(spender: any, value: any) {
    let decimal = await this.tokenDecimal;
    const params = [
      spender,
      this.bxHelper.decimalMultipler(Number(decimal), value),
    ];
    console.log('decrease allowance params : ', params);
    return await this.userTokenInstance.methods
      .decreaseAllowance(...params)
      .encodeABI();
  }

  // public decreaseAllowance(
  //   walletAddress: string,
  //   tokenAddress: any,
  //   decreaseAllowanceAbi: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: decreaseAllowanceAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async burnAbi(tokenAmount: any) {
    let decimal = await this.tokenDecimal;
    const params = [
      this.bxHelper.decimalMultipler(Number(decimal), tokenAmount),
    ];
    console.log('burn token params : ', params);
    return await this.userTokenInstance.methods.burn(...params).encodeABI();
  }

  // public burn(walletAddress: string, tokenAddress: any, burnAbi: any) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: burnAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async burnFromAbi(account: any, tokenAmount: any) {
    let decimal = await this.tokenDecimal;
    const params = [
      account,
      this.bxHelper.decimalMultipler(Number(decimal), tokenAmount),
    ];
    console.log('burnFrom params : ', params);
    return await this.userTokenInstance.methods.burnFrom(...params).encodeABI();
  }

  // public burnFrom(walletAddress: string, tokenAddress: any, burnFromAbi: any) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: burnFromAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }
  public async mintAbi(tokenAmount: any) {
    let decimal = await this.tokenDecimal;
    const params = [
      this.bxHelper.decimalMultipler(Number(decimal), tokenAmount),
    ];
    console.log('mint token params : ', params);
    return await this.userTokenInstance.methods.mint(...params).encodeABI();
  }

  // public mint(walletAddress: string, tokenAddress: any, mintAbi: any) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: mintAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async excludeFromDexFeeAbi(account: any) {
    const params = [account];
    console.log('exclude from dex fee params : ', params);
    return await this.userTokenInstance.methods
      .excludeFromDexFee(...params)
      .encodeABI();
  }

  // public excludeFromDexFee(
  //   walletAddress: string,
  //   excludeFromDexFeeAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: excludeFromDexFeeAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async excludeFromRewardAbi(account: any) {
    const params = [account];
    console.log('exclude from reward params : ', params);
    return await this.userTokenInstance.methods
      .excludeFromReward(...params)
      .encodeABI();
  }

  // public excludeFromReward(
  //   walletAddress: string,
  //   excludeFromRewardAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: excludeFromRewardAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async includeInDexFeeAbi(account: any) {
    const params = [account];
    console.log('include in dex fee params : ', params);
    return await this.userTokenInstance.methods
      .includeInDexFee(...params)
      .encodeABI();
  }

  // public includeInDexFee(
  //   walletAddress: string,
  //   includeInDexFeeAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: includeInDexFeeAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async includeInRewardAbi(account: any) {
    const params = [account];
    console.log('include in reward params : ', params);
    return await this.userTokenInstance.methods
      .includeInReward(...params)
      .encodeABI();
  }

  // public includeInReward(
  //   walletAddress: string,
  //   includeInRewardAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: includeInRewardAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async grantRoleAbi(role: any, account: any) {
    const params = [role, account];
    console.log('grant role params : ', params);
    return await this.userTokenInstance.methods
      .grantRole(...params)
      .encodeABI();
  }

  // public grantRole(
  //   walletAddress: string,
  //   grantRoleAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: grantRoleAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async renounceRoleAbi(role: any, account: any) {
    const params = [role, account];
    console.log('renounce role params : ', params);
    return await this.userTokenInstance.methods
      .renounceRole(...params)
      .encodeABI();
  }

  // public renounceRole(
  //   walletAddress: string,
  //   renounceRoleAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: renounceRoleAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async revokeRoleAbi(role: any, account: any) {
    const params = [role, account];
    console.log('revoke role params : ', params);
    return await this.userTokenInstance.methods
      .revokeRole(...params)
      .encodeABI();
  }

  // public revokeRole(
  //   walletAddress: string,
  //   revokeRoleAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: revokeRoleAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async setValuesAbi(
    reflectionFee: any,
    liquidityFee: any,
    liquidityFeeToSell: any,
    marketingFee: any,
    marketingFeeToSell: any,
    marketingAddress: any,
    charityFee: any,
    charityFeeToSell: any,
    charityAddress: any,
    transactionLimit: any
  ) {
    const params = [
      reflectionFee,
      liquidityFee,
      liquidityFeeToSell,
      marketingFee,
      marketingFeeToSell,
      marketingAddress,
      charityFee,
      charityFeeToSell,
      charityAddress,
      transactionLimit,
    ];
    console.log('set values params : ', params);
    return await this.userTokenInstance.methods
      .setValues(...params)
      .encodeABI();
  }

  // public setValues(
  //   walletAddress: string,
  //   setValuesAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: setValuesAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async updateCharityAddressAbi(account: any) {
    const params = [account];
    console.log('update charity address params : ', params);
    return await this.userTokenInstance.methods
      .updateCharityAddress(...params)
      .encodeABI();
  }

  // public updateCharityAddress(
  //   walletAddress: string,
  //   updateCharityAddressAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: updateCharityAddressAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async updateCharityFeeAbi(feeInPercentage: any) {
    const params = [feeInPercentage];
    console.log('update charity fee params : ', params);
    return await this.userTokenInstance.methods
      .updateCharityFee(...params)
      .encodeABI();
  }

  // public updateCharityFee(
  //   walletAddress: string,
  //   updateCharityFeeAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: updateCharityFeeAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async updateCharityFeeToSellAbi(feeToSell: any) {
    let decimal = await this.tokenDecimal;
    const params = [this.bxHelper.decimalMultipler(Number(decimal), feeToSell)];
    console.log('update charity fee to sell params : ', params);
    return await this.userTokenInstance.methods
      .updateCharityFeeToSell(...params)
      .encodeABI();
  }

  // public updateCharityFeeToSell(
  //   walletAddress: string,
  //   updateCharityFeeToSellAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: updateCharityFeeToSellAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async updateEnableFeeAbi(enabled: any) {
    const params = [enabled];
    console.log('update enable fee params : ', params);
    return await this.userTokenInstance.methods
      .updateEnableFee(...params)
      .encodeABI();
  }

  // public updateEnableFee(
  //   walletAddress: string,
  //   updateEnableFeeAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: updateEnableFeeAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async updateEnableMaxTransactionAmountAbi(enabled: any) {
    const params = [enabled];
    console.log('update enable max transaction amount params : ', params);
    return await this.userTokenInstance.methods
      .updateEnableMaxTransactionAmount(...params)
      .encodeABI();
  }

  // public updateEnableMaxTransactionAmount(
  //   walletAddress: string,
  //   updateEnableMaxTransactionAmountAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: updateEnableMaxTransactionAmountAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async updateLiquidityFeeAbi(feeInPercentage: any) {
    const params = [feeInPercentage];
    console.log('update liquidity fee params : ', params);
    return await this.userTokenInstance.methods
      .updateLiquidityFee(...params)
      .encodeABI();
  }

  // public updateLiquidityFee(
  //   walletAddress: string,
  //   updateLiquidityFeeAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: updateLiquidityFeeAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async updateLiquidityFeeToSellAbi(liquidityFeeToSell: any) {
    let decimal = await this.tokenDecimal;
    const params = [
      this.bxHelper.decimalMultipler(Number(decimal), liquidityFeeToSell),
    ];
    console.log('update liquidity fee to sell params : ', params);
    return await this.userTokenInstance.methods
      .updateLiquidityFeeToSell(...params)
      .encodeABI();
  }

  // public updateLiquidityFeeToSell(
  //   walletAddress: string,
  //   updateLiquidityFeeToSellAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: updateLiquidityFeeToSellAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async updateMarketingAddressAbi(account: any) {
    const params = [account];
    console.log('update marketing address params : ', params);
    return await this.userTokenInstance.methods
      .updateMarketingAddress(...params)
      .encodeABI();
  }

  // public updateMarketingAddress(
  //   walletAddress: string,
  //   updateMarketingAddressAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: updateMarketingAddressAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async updateMarketingFeeAbi(feeInPercentage: any) {
    const params = [feeInPercentage];
    console.log('update marketing fee params : ', params);
    return await this.userTokenInstance.methods
      .updateMarketingFee(...params)
      .encodeABI();
  }

  // public updateMarketingFee(
  //   walletAddress: string,
  //   updateMarketingFeeAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: updateMarketingFeeAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async updateMarketingFeeToSellAbi(feeToSell: any) {
    let decimal = await this.tokenDecimal;
    const params = [this.bxHelper.decimalMultipler(Number(decimal), feeToSell)];
    console.log('update marketing fee to sell params : ', params);
    return await this.userTokenInstance.methods
      .updateMarketingFeeToSell(...params)
      .encodeABI();
  }

  // public updateMarketingFeeToSell(
  //   walletAddress: string,
  //   updateMarketingFeeToSellAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: updateMarketingFeeToSellAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async updateReflectionFeeAbi(feeInPercentage: any) {
    const params = [feeInPercentage];
    console.log('update reflection fee params : ', params);
    return await this.userTokenInstance.methods
      .updateReflectionFee(...params)
      .encodeABI();
  }

  // public updateReflectionFee(
  //   walletAddress: string,
  //   updateReflectionFeeAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: updateReflectionFeeAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async updateSwapAndLiquifyEnabledAbi(enabled: any) {
    const params = [enabled];
    console.log('update swap & liquify enabled params : ', params);
    return await this.userTokenInstance.methods
      .updateSwapAndLiquifyEnabled(...params)
      .encodeABI();
  }

  // public updateSwapAndLiquifyEnabled(
  //   walletAddress: string,
  //   updateSwapAndLiquifyEnabledAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: updateSwapAndLiquifyEnabledAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async updateTransactionLimitAbi(limitInPercentage: any) {
    const params = [limitInPercentage];
    console.log('update transaction limit params : ', params);
    return await this.userTokenInstance.methods
      .updateTransactionLimit(...params)
      .encodeABI();
  }

  // public updateTransactionLimit(
  //   walletAddress: string,
  //   updateTransactionLimitAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: updateTransactionLimitAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async withdrawBEP20TokenAbi(tokenAddress: any, tokenAmount: any) {
    let decimal = await this.tokenDecimal;
    const params = [
      tokenAddress,
      this.bxHelper.decimalMultipler(Number(decimal), tokenAmount),
    ];
    console.log('withdraw BEP20 token params : ', params);
    return await this.userTokenInstance.methods
      .withdrawBEP20Token(...params)
      .encodeABI();
  }

  // public withdrawBEP20Token(
  //   walletAddress: string,
  //   withdrawBEP20TokenAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: withdrawBEP20TokenAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async withdrawBnbFromContractAbi(account: any, amount: any) {
    const params = [
      account,
      this.bxHelper.decimalMultipler(Number(18), amount),
    ];
    console.log('withdraw BNB from contract params : ', params);
    return await this.userTokenInstance.methods
      .withdrawBnbFromContract(...params)
      .encodeABI();
  }

  // public withdrawBnbFromContract(
  //   walletAddress: string,
  //   withdrawBnbFromContractAbi: any,
  //   tokenAddress: any
  // ) {
  //   return new Promise((resolve, reject) => {
  //     const message = {
  //       method: 'eth_sendTransaction',
  //       from: walletAddress,
  //       to: tokenAddress,
  //       data: withdrawBnbFromContractAbi,
  //     };
  //     console.log(message);
  //     this.commonContractService.ethWeb3.eth
  //       .sendTransaction(message)
  //       .then((receipt: any) => {
  //         resolve({ status: true, data: receipt });
  //       })
  //       .catch((error: any) => {
  //         reject({ status: false, data: error });
  //       });
  //   });
  // }

  public async getStandardTokenReadFunctionsDetails(tokenType: any) {
    let tokenDecimal = await this.tokenDecimal;
    let tokenName = await this.userTokenInstance.methods.name().call();
    let owner = await this.userTokenInstance.methods.owner().call();
    let isPaused = await this.userTokenInstance.methods.paused().call();
    let tokenSymbol = await this.userTokenInstance.methods.symbol().call();
    let totalSupplyInWei = await this.userTokenInstance.methods
      .totalSupply()
      .call();
    let totalSupply = await this.commonContractService.decimalDivider(
      Number(tokenDecimal),
      totalSupplyInWei
    );
    let type = tokenType;
    return {
      tokenDecimal,
      tokenName,
      owner,
      isPaused,
      tokenSymbol,
      totalSupply,
      type,
    };
  }

  public async getLiquidityTokenReadFunctionsDetails(tokenType: any) {
    let tokenDecimal = await this.tokenDecimal;
    let tokenName = await this.userTokenInstance.methods.name().call();
    let owner = await this.userTokenInstance.methods.owner().call();
    let isPaused = await this.userTokenInstance.methods.paused().call();
    let tokenSymbol = await this.userTokenInstance.methods.symbol().call();
    let totalSupplyInWei = await this.userTokenInstance.methods
      .totalSupply()
      .call();
    let totalSupply = await this.commonContractService.decimalDivider(
      Number(tokenDecimal),
      totalSupplyInWei
    );

    let default_admin_role = await this.userTokenInstance.methods
      .DEFAULT_ADMIN_ROLE()
      .call();
    let liquidity_generator_role = await this.userTokenInstance.methods
      .LIQUIDITY_GENERATOR_ROLE()
      .call();

    let charityAddress = await this.userTokenInstance.methods
      .charityAddress()
      .call();
    let charityFee = await this.userTokenInstance.methods.charityFee().call();
    let charityFeeBalanceInWei = await this.userTokenInstance.methods
      .charityFeeBalance()
      .call();
    let charityFeeBalance = await this.commonContractService.decimalDivider(
      Number(tokenDecimal),
      charityFeeBalanceInWei
    );
    let charityFeeToSellInWei = await this.userTokenInstance.methods
      .charityFeeToSell()
      .call();
    // let charityFeeToSell = await this.commonContractService.decimalDivider(
    //   Number(tokenDecimal),
    //   charityFeeToSellInWei
    // );

    let charityFeeToSell = await charityFeeToSellInWei;

    let enableFee = await this.userTokenInstance.methods.enableFee().call();
    let enableMaxTransactionAmount = await this.userTokenInstance.methods
      .enableMaxTransactionAmount()
      .call();

    let liquidityFee = await this.userTokenInstance.methods
      .liquidityFee()
      .call();
    let liquidityFeeBalanceInWei = await this.userTokenInstance.methods
      .liquidityFeeBalance()
      .call();
    let liquidityFeeBalance = await this.commonContractService.decimalDivider(
      Number(tokenDecimal),
      liquidityFeeBalanceInWei
    );
    let liquidityFeeToSellInWei = await this.userTokenInstance.methods
      .liquidityFeeToSell()
      .call();
    // let liquidityFeeToSell = await this.commonContractService.decimalDivider(
    //   Number(tokenDecimal),
    //   liquidityFeeToSellInWei
    // );
    let liquidityFeeToSell = await liquidityFeeToSellInWei;

    let marketingAddress = await this.userTokenInstance.methods
      .marketingAddress()
      .call();
    let marketingFee = await this.userTokenInstance.methods
      .marketingFee()
      .call();
    let marketingFeeBalanceInWei = await this.userTokenInstance.methods
      .marketingFeeBalance()
      .call();
    let marketingFeeBalance = await this.commonContractService.decimalDivider(
      Number(tokenDecimal),
      marketingFeeBalanceInWei
    );
    let marketingFeeToSellInWei = await this.userTokenInstance.methods
      .marketingFeeToSell()
      .call();
    // let marketingFeeToSell = await this.commonContractService.decimalDivider(
    //   Number(tokenDecimal),
    //   marketingFeeToSellInWei
    // );

    let marketingFeeToSell = await marketingFeeToSellInWei;

    let reflectionFee = await this.userTokenInstance.methods
      .reflectionFee()
      .call();
    let swapAndLiquifyEnabled = await this.userTokenInstance.methods
      .swapAndLiquifyEnabled()
      .call();
    let totalFeesInWei = await this.userTokenInstance.methods
      .totalFees()
      .call();
    let totalFees = await this.commonContractService.decimalDivider(
      Number(tokenDecimal),
      totalFeesInWei
    );
    let transactionLimit = await this.userTokenInstance.methods
      .transactionLimit()
      .call();
    let uniswapV2Pair = await this.userTokenInstance.methods
      .uniswapV2Pair()
      .call();
    let uniswapV2Router = await this.userTokenInstance.methods
      .uniswapV2Router()
      .call();

    let type = tokenType;

    return {
      tokenDecimal,
      tokenName,
      owner,
      isPaused,
      tokenSymbol,
      totalSupply,
      default_admin_role,
      liquidity_generator_role,
      charityAddress,
      charityFee,
      charityFeeBalance,
      charityFeeToSell,
      enableFee,
      enableMaxTransactionAmount,
      liquidityFee,
      liquidityFeeBalance,
      liquidityFeeToSell,
      marketingAddress,
      marketingFee,
      marketingFeeBalance,
      marketingFeeToSell,
      reflectionFee,
      swapAndLiquifyEnabled,
      totalFees,
      transactionLimit,
      uniswapV2Pair,
      uniswapV2Router,
      type,
    };
  }

  public async getAllowance(owner: any, spender: any) {
    // return this.userTokenInstance.methods.allowance(owner, spender).call();
    return this.commonContractService.decimalDivider(
      Number(this.tokenDecimal),
      await this.userTokenInstance.methods.allowance(owner, spender).call()
    );
  }

  public async getBalanceOf(account: any) {
    return this.commonContractService.decimalDivider(
      Number(this.tokenDecimal),
      await this.userTokenInstance.methods.balanceOf(account).call()
    );
  }

  public async getRoleAdmin(role: any) {
    return this.userTokenInstance.methods.getRoleAdmin(role).call();
  }

  public async getHasRole(byte: any, address: any) {
    return this.userTokenInstance.methods.getRoleAdmin(byte, address).call();
  }

  public async getIsExcludedFromDexFee(address: any) {
    return this.userTokenInstance.methods.isExcludedFromDexFee(address).call();
  }

  public async getIsExcludedFromReward(address: any) {
    return this.userTokenInstance.methods.isExcludedFromReward(address).call();
  }

  public async getSupportInterface(id: any) {
    return this.userTokenInstance.methods.supportsInterface(id).call();
  }

  public async getTokenFromReflection(amount: any) {
    return this.userTokenInstance.methods.tokenFromReflection(amount).call();
  }

  public callTransactionWithAbi(
    walletAddress: string,
    tokenAddress: any,
    abi: any
  ) {
    return new Promise((resolve, reject) => {
      const message = {
        method: 'eth_sendTransaction',
        from: walletAddress,
        to: tokenAddress,
        data: abi,
      };
      console.log(message);
      this.commonContractService.ethWeb3.eth
        .sendTransaction(message)
        .then((receipt: any) => {
          resolve({ status: true, data: receipt });
        })
        .catch((error: any) => {
          reject({ status: false, data: error });
        });
    });
  }
}
